module.exports = __webpack_public_path__ + "static/media/compensation-icon.ef61aebb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/compensation-icon.svg
// module id = 189
// module chunks = 0